import { render, staticRenderFns } from "./odatipleri.vue?vue&type=template&id=626de00e&"
import script from "./odatipleri.vue?vue&type=script&lang=js&"
export * from "./odatipleri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports